import { render } from "./MindUpMatchRuleDialog.vue?vue&type=template&id=71ecba49&scoped=true&ts=true"
import script from "./MindUpMatchRuleDialog.vue?vue&type=script&lang=ts"
export * from "./MindUpMatchRuleDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ecba49"]])

export default __exports__